export const baseUrl = import.meta.env.PROD ? 'https://laravel.menucaddy.com' : 'http://localhost:8000'
export const baseApiUrl = `${baseUrl}/api`
